import { render, staticRenderFns } from "./SimpleEventList.vue?vue&type=template&id=faa6bb86&"
import script from "./SimpleEventList.vue?vue&type=script&lang=js&"
export * from "./SimpleEventList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports